import { useRouteTranslation } from '@/hooks/useRouteTranslation'

export default function ShahadaBlessedSection() {
  const { t, lng } = useRouteTranslation()
  const isRTL = lng === 'ar' || lng === 'ur'
  const isEnglishContent = lng === 'en'

  return (
    <div>
      <div className="container mx-auto max-w-4xl px-4">
        <div className="relative">
          <div
            className="relative rounded-[20px] bg-gradient-to-br from-[#01B87A] to-[#059669] pb-6 text-center text-white dark:from-green-800 dark:to-green-900 md:pb-40 md:pt-2"
            style={{ boxShadow: '0 10px 24px rgba(16, 24, 40, 0.10)', border: '1px solid rgba(16, 24, 40, 0.04)' }}
          >
            <div className="px-6 pb-2 pt-8 md:px-10 md:pb-8 md:pt-10">
              <h3 className="mb-6 text-xl font-bold md:text-2xl">
                {t('islam.shahada.title', 'الشهادتان - نص مبارك')}
              </h3>
              <div className="mb-4 flex justify-center">
                <img
                  src="/assets/sahahada_image.png"
                  alt={t('islam.shahada.title', 'الشهادتان - نص مبارك')}
                  className="h-auto max-w-full w-[240px] md:w-[300px] lg:w-[360px]"
                  onError={(e) => {
                    const target = e.currentTarget
                    target.style.display = 'none'
                  }}
                />
              </div>
              <div
                className="mx-auto max-w-2xl pb-2 text-base leading-relaxed md:pb-6 md:text-lg md:leading-relaxed"
                dir={isEnglishContent ? 'ltr' : 'rtl'}
              >
                {isEnglishContent ? (
                  <>
                    <span className="block">{t('islam.shahada.meaningEn1', 'I bear witness that there is no god worthy of worship but Allah alone,')}</span>
                    <span className="block">{t('islam.shahada.meaningEn2', 'with no partner')}</span>
                    <span className="mt-2 block md:mt-2.5">{t('islam.shahada.meaningEn3', 'And I bear witness that Muhammad is His servant and Messenger')}</span>
                  </>
                ) : (
                  <>
                    {t('islam.shahada.meaning1', 'أشهد أن لا معبود بحق إلا الله وحده لا شريك له')}
                    <br />
                    {t('islam.shahada.meaning2', 'وأشهد أن محمدًا عبده ورسوله')}
                  </>
                )}
              </div>
            </div>

            <div className="relative z-10 mx-auto mt-6 w-full max-w-[min(100%,calc(100vw-2rem))] px-2 md:absolute md:bottom-5 md:left-1/2 md:mt-0 md:w-[calc(100%+32px)] md:max-w-none md:-translate-x-1/2 md:px-0">
              <div className="mx-auto overflow-hidden rounded-[18px] border-0 bg-white shadow-[0_8px_28px_rgba(16,24,40,0.12)] dark:bg-gray-800 dark:shadow-[0_12px_32px_rgba(0,0,0,0.35)]">
                <div
                  className="flex flex-col-reverse items-stretch md:flex-row md:items-center"
                  dir={isRTL ? 'rtl' : 'ltr'}
                >
                  <div
                    className="flex min-w-0 flex-1 flex-col justify-center px-5 py-4 text-start md:px-6 md:py-4"
                  >
                    <h3 className="mb-1 text-base font-bold text-[#01B87A] dark:text-emerald-400 md:mb-1.5 md:text-lg">
                      {t('islam.entering.footer.congrats', 'تهانينا! 🌙')}
                    </h3>
                    <p
                      className="text-[13px] leading-relaxed text-gray-800 dark:text-gray-200 md:text-[14px] md:leading-snug"
                      dir={isEnglishContent ? 'ltr' : 'rtl'}
                    >
                      <span className="block">
                        {t(
                          'islam.entering.footer.descLine1',
                          'When you declare the Shahada with sincerity, all your past sins are forgiven and you begin a new pure page with Allah.',
                        )}
                      </span>
                      <span className="block">
                        {t(
                          'islam.entering.footer.descLine2',
                          'The angels rejoice, the heavens celebrate, and you are now part of the great',
                        )}
                      </span>
                      <span className="block">{t('islam.entering.footer.descLine3', 'Muslim Ummah.')}</span>
                    </p>
                  </div>
                  <div className="relative h-36 w-full shrink-0 md:h-[168px] md:w-[200px] md:min-w-[180px] lg:h-[176px] lg:w-[228px]">
                    <img
                      src="/assets/contgrtas.png"
                      alt={t('islam.entering.footer.imageAlt', 'صورة الدعاء أمام الكعبة')}
                      className="absolute inset-0 h-full w-full object-cover"
                      onError={(e) => {
                        const target = e.currentTarget
                        target.style.display = 'none'
                        const parent = target.parentElement
                        if (parent) {
                          parent.innerHTML = `
                              <div class="absolute inset-0 flex items-center justify-center bg-gray-100 dark:bg-gray-700">
                              <svg class="h-12 w-12 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                              </svg>
                            </div>
                            `
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
